import React, { useContext } from "react";
import InputSearchTag from "core/inputs/input-search/InputSearchTag";
import { formatClientOptions } from "components/form/CommonInputs";
import { TAG_TYPES } from "constants/constants";
import { FORM_INFO } from "constants/forms";
import InfoContext from "pages/InfoContext";

const ClientsField = () => {
  const {
    clientsFilter,
    storedClients,
    setStoredClients,
    setValue,
    getClients,
    clientsList,
  } = useContext(InfoContext);

  return (
    <InputSearchTag
      errors={{}}
      required={false}
      getOptions={getClients}
      label={{
        id: "clients",
        defaultMessage: "Clients",
      }}
      limitChoice={10}
      minLength={1}
      onDelete={(deleted) => {
        setStoredClients(
          storedClients.filter((item) => item.value !== deleted)
        );
        return setValue(
          "clients_filter",
          clientsFilter.filter((item) => item.value !== deleted)
        );
      }}
      options={formatClientOptions(clientsList)}
      popup={FORM_INFO.clientFilter.popup}
      selectedOptions={clientsFilter}
      setValue={(newValue) => {
        setStoredClients(newValue);
        return setValue("clients_filter", newValue);
      }}
      type={TAG_TYPES.CLIENTS}
      id="client-filter"
    />
  );
};

export default ClientsField;
